export default "__VITE_ASSET__D6rCiq9u__"